import React, { useState, useMemo } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`

const zoomLevels = [50, 75, 100, 125, 150, 200, 300, 400]

const DocumentView = (props) => {
    const { fileUrl, showZoomControl } = props
    const [numPages, setNumPages] = useState(null)
    const [scale, setScale] = useState(1.3)
    const [showDropdown, setShowDropdown] = useState(false)

    const options = useMemo(() => ({
        cMapUrl: 'https://unpkg.com/pdfjs-dist@3.11.174/cmaps/',
        cMapPacked: true
    }), [])

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages)
    }

    const handleDownload = () => {
        fetch(fileUrl)
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = 'document.pdf'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        })
    }

    const handleZoomLevelSelect = (level) => {
        setScale(level / 100)
        setShowDropdown(false)
    }

    return (
        <div className='document-view' style={{ textAlign: 'center' }}>
            {
                showZoomControl &&
                <div className="pdf-toolbar">
                    <button onClick={() => setScale(Math.max(scale - 0.1, 0.5))}>➖</button>
                    <div style={{ position: 'relative' }}>
                        <button onClick={() => setShowDropdown(!showDropdown)} >
                            {Math.round(scale * 100)}% ▾
                        </button>
                        {showDropdown && (
                            <div className='pdf-zoom-dropdown'>
                                <div style={{ padding: '5px', cursor: 'pointer' }} onClick={() => handleZoomLevelSelect(125)}> Actual size </div>
                                <div style={{ padding: '5px', cursor: 'pointer' }} onClick={() => handleZoomLevelSelect(130)}> Page width </div>
                                {zoomLevels.map((level) => (
                                    <div key={level} style={{ padding: '5px', cursor: 'pointer' }} onClick={() => handleZoomLevelSelect(level)}> {level}% </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <button onClick={() => setScale(Math.min(scale + 0.1, 4))} >➕</button>
                    <button onClick={handleDownload} >⬇️</button>
                </div>
            }

            <div className='flex flex-column h-full w-full' style={{ width: '85vw', height: '85vh', overflow: 'auto' }}>
                <div className='justify-content-center align-items-center overflow-auto' style={{ overflow: 'auto', alignItems: 'center' }}>
                    <Document
                        key={fileUrl}
                        file={fileUrl}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={(error) => console.error('PDF load error:', error)}
                        options={options}
                    >
                        {Array.from(new Array(numPages), (el, index) => (
                            <Page
                                key={`page_${index + 1}`}
                                pageNumber={index + 1}
                                scale={scale}
                                renderAnnotationLayer={false}
                                renderTextLayer={true}
                            />
                        ))}
                    </Document>
                </div>
            </div>
        </div>
    )
}

export default DocumentView
